import { Link } from "react-router-dom";
import { siteInfo, starProfile } from "@/mocks/star";

export default function IntroSection() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-[420px_1fr] gap-8 lg:gap-12 items-center">
      <div className="relative w-full h-[420px] md:h-[480px] rounded-lg overflow-hidden bg-background-200">
        <img
          src={starProfile.avatar}
          alt={`${starProfile.name} 肖像`}
          title={`${starProfile.name} - 影视明星资料`}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-primary-950/90 to-transparent">
          <p className="font-heading text-lg font-semibold text-background-50">{starProfile.name}</p>
          <p className="text-xs text-background-50/70 tracking-widest">{starProfile.romajiName}</p>
        </div>
      </div>

      <div>
        <p className="text-xs md:text-sm font-medium text-accent-700 tracking-widest mb-2">
          ABOUT THIS SITE
        </p>
        <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-semibold text-foreground-950">
          关于本站
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          {siteInfo.intro}
        </p>
        <p className="mt-4 text-sm text-foreground-600 leading-relaxed">{starProfile.intro}</p>

        <blockquote className="mt-6 pl-5 border-l-2 border-accent-400 text-foreground-800 text-sm md:text-base leading-relaxed italic">
          {starProfile.belief}
        </blockquote>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-user-star-line"></i>
            </span>
            了解更多明星资料
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 px-5 h-11 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-film-line"></i>
            </span>
            浏览全部作品
          </Link>
        </div>
      </div>
    </section>
  );
}